export const GET_SINGLE_MATTERS_REQUEST = "GET_SINGLE_MATTERS_REQUEST";
export const GET_SINGLE_MATTERS_SUCCESS = "GET_SINGLE_MATTERS_SUCCESS";
export const GET_SINGLE_MATTERS_FAIL = "GET_SINGLE_MATTERS_FAIL";
export const GET_SINGLE_MATTERS_RESET = "GET_SINGLE_MATTERS_RESET";